module.exports = __webpack_public_path__ + "static/media/foro_react.08c1e640.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/portfolio/foro_react.png
// module id = 438
// module chunks = 0